import * as Format from "../../common/FormatFunctions";
import * as log from "../../common/Feedback/Log";

export const renderPieOptions = () => {
  var chartOptionBean = {};

  chartOptionBean.chartArea = {
    bottom: null,
    left: null,
    top: null,
    right: null,
    width: "75%",
    height: "75%"
  };
  chartOptionBean.pieSliceText = "label";
  chartOptionBean.title = "";

  //Optional
  // chartOptionBean.pieStartAngle = 100;
  // chartOptionBean.legend = "none";
  // chartOptionBean.sliceVisibilityThreshold = 0.2;
  return chartOptionBean;
};

export const renderPieData = () => {
  var chartDataBean = {};

  chartDataBean.rows = [];
  chartDataBean.columns = [];

  chartDataBean.columns = [
    { label: "Jobs", type: "string", id: null },
    { label: "In Progress", type: "number", id: null }
  ];
  chartDataBean.rows.push(["In Progress", 75]);
  chartDataBean.rows.push(["Overdue", 10]);
  chartDataBean.rows.push(["Not Started", 15]);

  return chartDataBean;
};

export const renderPieDataIt2 = () => {
  var chartDataBean = {};

  chartDataBean.rows = [];
  chartDataBean.columns = [];

  chartDataBean.columns = [
    { label: "Jobs", type: "string", id: null },
    { label: "In Progress", type: "number", id: null }
  ];
  chartDataBean.rows.push(["In Progress", 80]);
  chartDataBean.rows.push(["Overdue", 10]);
  chartDataBean.rows.push(["Not Started", 10]);

  return chartDataBean;
};

export const renderAreaOptions = () => {
  var chartOptionBean = {};

  chartOptionBean.chartArea = {
    bottom: null,
    left: null,
    top: null,
    right: null,
    width: "75%",
    height: "75%"
  };
  chartOptionBean.title = "Using Objects";
  chartOptionBean.hAxis = { title: "Year", minValue: 0 };
  chartOptionBean.vAxis = { title: "", minValue: 0 };

  //Optional

  // chartOptionBean.legend = "none";

  return chartOptionBean;
};

export const renderAreaData = () => {
  var chartDataBean = {};

  chartDataBean.rows = [];
  chartDataBean.columns = [];

  chartDataBean.columns = [
    { label: "Years", type: "string", id: null },
    { label: "Sales", type: "number", id: null },
    { label: "Expenses", type: "number", id: null }
  ];
  chartDataBean.rows.push(["2013", 1000, 400]);
  chartDataBean.rows.push(["2014", 1170, 460]);
  chartDataBean.rows.push(["2015", 660, 1120]);
  chartDataBean.rows.push(["2016", 1030, 540]);
  chartDataBean.rows.push(["2017", 890, 378]);

  return chartDataBean;
};

export const renderBarOptions = () => {
  var chartOptionBean = {};

  chartOptionBean.chartArea = {
    bottom: null,
    left: null,
    top: null,
    right: null,
    width: "75%",
    height: "75%"
  };
  chartOptionBean.title = "";
  chartOptionBean.hAxis = { title: "Station", minValue: 0 };
  chartOptionBean.vAxis = { title: "Productivity(%)", minValue: 0 };

  //Optional

  chartOptionBean.colors = ["#00ff00", "#ffab91"];

  return chartOptionBean;
};

export const renderBarData = () => {
  var chartDataBean = {};

  chartDataBean.rows = [];
  chartDataBean.columns = [];

  chartDataBean.columns = [
    { label: "Stations", type: "string", id: null },
    { label: "Productivity", type: "number", id: null }
  ];
  chartDataBean.rows.push(["Station 1", 80]);
  chartDataBean.rows.push(["Sttaion 2", 65]);
  chartDataBean.rows.push(["Station 3", 78]);
  chartDataBean.rows.push(["Sttaion 4", 90]);
  chartDataBean.rows.push(["Station 5", 45]);

  console.log(chartDataBean.rows);

  return chartDataBean;
};
export const renderBarDataIt2 = () => {
  var chartDataBean = {};

  chartDataBean.rows = [];
  chartDataBean.columns = [];

  chartDataBean.columns = [
    { label: "Stations", type: "string", id: null },
    { label: "Productivity", type: "number", id: null }
  ];
  chartDataBean.rows.push(["Station 6", 90]);
  chartDataBean.rows.push(["Sttaion 7", 55]);
  chartDataBean.rows.push(["Station 8", 88]);
  chartDataBean.rows.push(["Station 9", 67]);
  chartDataBean.rows.push(["Station 10", 56]);

  console.log(chartDataBean.rows);

  return chartDataBean;
};
export const renderBarDataIt3 = () => {
  var chartDataBean = {};

  chartDataBean.rows = [];
  chartDataBean.columns = [];

  chartDataBean.columns = [
    { label: "Stations", type: "string", id: null },
    { label: "Productivity", type: "number", id: null }
  ];
  chartDataBean.rows.push(["Station 11", 70, 90]);
  chartDataBean.rows.push(["Sttaion 12", 63]);
  chartDataBean.rows.push(["Station 13", 49]);
  chartDataBean.rows.push(["Sttaion 14", 56]);
  chartDataBean.rows.push(["Station 15", 77]);

  console.log(chartDataBean.rows);

  return chartDataBean;
};

export const renderTimelineOptions = () => {
  var chartOptionBean = {};

  chartOptionBean.chartArea = {
    bottom: null,
    left: null,
    top: null,
    right: null,
    width: "75%",
    height: "75%"
  };
  chartOptionBean.title = "Using Objects";
  chartOptionBean.timeline = { colorByRowLabel: false };

  //Optional
  // chartOptionBean.backgroundColor = "#043066";

  return chartOptionBean;
};

export const renderTimelineData = () => {
  var chartDataBean = {};

  chartDataBean.rows = [];
  chartDataBean.columns = [];

  chartDataBean.columns = [
    { label: null, type: "string", id: "Tool" },
    { label: null, type: "string", id: "Name" },
    { label: null, type: "date", id: "Start" },
    { label: null, type: "date", id: "End" }
  ];
  chartDataBean.rows.push([
    "CNC",
    "UpTime",
    new Date(1789, 3, 30),
    new Date(1797, 2, 4)
  ]);
  chartDataBean.rows.push([
    "CNC",
    "DownTime",
    new Date(1797, 2, 4),
    new Date(1801, 2, 4)
  ]);
  chartDataBean.rows.push([
    "CNC",
    "UpTime",
    new Date(1801, 2, 4),
    new Date(1809, 2, 4)
  ]);

  return chartDataBean;
};

export const renderGuageOptions = () => {
  var chartOptionBean = {};

  chartOptionBean.chartArea = {
    bottom: null,
    left: null,
    top: null,
    right: null,
    width: "100%",
    height: "100%"
  };
  chartOptionBean.title = "Using Objects";
  chartOptionBean.redFrom = 0;
  chartOptionBean.redTo = 20;
  chartOptionBean.yellowFrom = 20;
  chartOptionBean.yellowTo = 50;
  chartOptionBean.greenFrom = 60;
  chartOptionBean.greenTo = 100;
  chartOptionBean.minorTicks = 5;
  //Optional

  return chartOptionBean;
};

export const renderGuageData = value => {
  var chartDataBean = {};

  chartDataBean.rows = [];
  chartDataBean.columns = [];

  chartDataBean.columns = [
    { label: "Label", type: "string", id: null },
    { label: "Value", type: "number", id: null }
  ];

  chartDataBean.rows.push(["OEE", value]);
  // chartDataBean.rows.push(["CPU", 55]);
  // chartDataBean.rows.push(["Network", 1]);

  console.log(value);
  return chartDataBean;
};
export const renderGuageDataExpanded = () => {
  var chartDataBean = {};

  chartDataBean.rows = [];
  chartDataBean.columns = [];

  chartDataBean.columns = [
    { label: "Label", type: "string", id: null },
    { label: "Value", type: "number", id: null }
  ];
  chartDataBean.rows.push(["Availability", 80]);
  chartDataBean.rows.push(["Performance", 55]);
  chartDataBean.rows.push(["Quality", 1]);

  return chartDataBean;
};

export const renderComboOptions = () => {
  var chartOptionBean = {};

  chartOptionBean.chartArea = {
    bottom: null,
    left: null,
    top: null,
    right: null,
    width: "75%",
    height: "75%"
  };
  chartOptionBean.title = "Using Objects";
  chartOptionBean.hAxis = { title: "Year", minValue: 0 };
  chartOptionBean.vAxis = { title: "Money($)", minValue: 0 };
  chartOptionBean.seriesType = "bars";
  chartOptionBean.series = { 1: { type: "line" } };

  //Optional

  chartOptionBean.colors = ["#b0120a", "#ffab91"];

  return chartOptionBean;
};

export const renderComboData = () => {
  var chartDataBean = {};

  chartDataBean.rows = [];
  chartDataBean.columns = [];

  chartDataBean.columns = [
    { label: "Years", type: "string", id: null },
    { label: "Sales", type: "number", id: null },
    { label: "Expenses", type: "number", id: null }
  ];
  chartDataBean.rows.push(["2013", 1000, 400]);
  chartDataBean.rows.push(["2014", 1170, 460]);
  chartDataBean.rows.push(["2015", 660, 1120]);
  chartDataBean.rows.push(["2016", 1030, 540]);
  chartDataBean.rows.push(["2017", 890, 378]);

  return chartDataBean;
};

export const renderGanttOptions = () => {
  var chartOptionBean = {};

  chartOptionBean.chartArea = {
    bottom: null,
    left: null,
    top: null,
    right: null,
    width: "75%",
    height: "75%"
  };
  chartOptionBean.title = "Using Objects";
  chartOptionBean.gantt = { criticalPathEnabled: true };

  //Optional

  return chartOptionBean;
};

export const renderGanttData = () => {
  var chartDataBean = {};

  chartDataBean.rows = [];
  chartDataBean.columns = [];

  chartDataBean.columns = [
    { type: "string", label: "Task ID", id: null },
    { type: "string", label: "Task Name", id: null },
    { type: "string", label: "Resource", id: null },
    { type: "date", label: "Start Date", id: null },
    { type: "date", label: "End Date", id: null },
    { type: "number", label: "Duration", id: null },
    { type: "number", label: "Percent Complete", id: null },
    { type: "string", label: "Dependencies", id: null }
  ];
  chartDataBean.rows.push([
    "FLO001",
    "Setup",
    null,
    new Date(2015, 0, 1),
    new Date(2015, 0, 5),
    null,
    100,
    null
  ]);
  chartDataBean.rows.push([
    "FLO002",
    "Scan",
    null,
    new Date(2015, 0, 3),
    new Date(2015, 0, 4),
    null,
    100,
    null
  ]);
  chartDataBean.rows.push([
    "FLO003",
    "Cut",
    null,
    new Date(2015, 0, 6),
    new Date(2015, 0, 7),
    null,
    75,
    "FLO001, FLO002"
  ]);
  chartDataBean.rows.push([
    "FLO004",
    "Join",
    null,
    new Date(2015, 0, 7),
    new Date(2015, 0, 9),
    null,
    0,
    "FLO001, FLO002, FLO003"
  ]);
  chartDataBean.rows.push([
    "FLO005",
    "Quality",
    null,
    new Date(2015, 0, 9),
    new Date(2015, 0, 11),
    null,
    0,
    "FLO001, FLO002, FLO003, FLO004"
  ]);

  return chartDataBean;
};

export const renderProductLeadTimeOptions = () => {
  var chartOptionBean = {};

  chartOptionBean.chartArea = {
    bottom: null,
    left: null,
    top: null,
    right: null,
    width: "50%",
    height: "75%"
  };
  chartOptionBean.title = "Product Expected vs Actual Lead Time";
  chartOptionBean.hAxis = { title: "Product", minValue: 0 };
  chartOptionBean.vAxis = { title: "Time(H)", minValue: 0 };

  //Optional

  chartOptionBean.colors = ["#0000ff", "#00ff00"];

  return chartOptionBean;
};

const getChartDataBeanColumns = () => {
  var columns = [];
  columns = [
    { label: "Product", type: "string", id: null },
    { label: "Actual", type: "number", id: null },
    { label: "Expected", type: "number", id: null }
  ];

  return columns;
};

export const renderProductLeadTimeData = () => {
  var chartDataBean = {};

  chartDataBean.rows = [];
  chartDataBean.columns = [];

  chartDataBean.columns = getChartDataBeanColumns();
  chartDataBean.rows.push(["Product A", 5, 7.6]);
  chartDataBean.rows.push(["Product B", 8, 6]);

  return chartDataBean;
};

export const renderProductLeadTimeDataPivot = () => {
  var chartDataBean = {};

  chartDataBean.data = [];

  var columns = getChartDataBeanColumns();

  chartDataBean.data = [];
  chartDataBean.data.push(parseIntoPivotTable(columns));

  chartDataBean.data.push(["Product A", 5, 7.6]);
  chartDataBean.data.push(["Product B", 8, 6]);

  return chartDataBean.data;
};

export const parseIntoPivotTable = jsonObject => {
  var localObject = {};
  if (Format.isNotNull(jsonObject)) {
    if (Array.isArray(jsonObject)) {
      jsonObject.forEach(element => {
        var objectTitle = "";
        for (var property in element) {
          if (property === "label") {
            objectTitle = element[property];
            localObject[objectTitle] = {};
          }
          if (property === "type") {
            localObject[objectTitle] = { [property]: element[property] };
          }
        }
      });
    }
  }
  log.info(localObject);
  return localObject;
};



// WEBPACK FOOTER //
// ./src/components/Statistics/ChartExamples.js